let cached = null;
let cachedAt = 0;
const CACHE_MS = 5 * 60 * 1000;

export function getUserCoords() {
  return new Promise((resolve) => {
    if (cached && Date.now() - cachedAt < CACHE_MS) return resolve(cached);
    if (!navigator.geolocation) return resolve(null);
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        cached = { lat: pos.coords.latitude, lng: pos.coords.longitude };
        cachedAt = Date.now();
        resolve(cached);
      },
      () => resolve(null),
      { timeout: 8000, maximumAge: CACHE_MS }
    );
  });
}
